export const APPROVE_ORDER_NUMBER_BLOCK_ID = 'approveOrderNumberBlock';
export const CHECKLISTS_TITLE_BLOCK_ID = 'checklistsTitleBlock';
export const COLLABORATING_KNO_NAME_BLOCK_ID = 'collaboratingKnoNameBlock';
export const DECISION_PLACE_BLOCK_ID = 'decisionPlaceBlock';
export const DURATION_DAYS_BLOCK_ID = 'durationDaysBlock';
export const DURATION_HOURS_BLOCK_ID = 'durationHoursBlock';
export const FORM_LINK_TYPE_FIELD_ID = 'formLinkTypeField';
export const EVENTS_BLOCK_ID = 'eventsBlock';
export const HEAD_ORDER_NUMBER_BLOCK_ID = 'headOrderNumberBlock';
export const IMPOSSIBLE_CONDUCTION_REASON_BLOCK_ID = 'impossibleConductionReasonBlock';
export const INN_LABEL_BLOCK_ID = 'innLabelBlock';
export const INSPECTION_TARGET_LABEL_BLOCK_ID = 'inspectionTargetLabelBlock';
export const INSPECTORS_TITLE_ID = 'inspectorsTitle';
export const KIND_BLOCK_ID = 'kindBlock';
export const KNO_ORGANIZATION_BLOCK_ID = 'knoOrganizationBlock';
export const KNO_ORGANIZATION_FUNCTIONS_TITLE_ID = 'knoOrganizationFunctionsTitle';
export const LEGAL_BASES_TITLE_ID = 'legalBasesTitle';
export const MONTH_BLOCK_ID = 'monthBlock';
export const NOTICE_DATE_BLOCK_ID = 'noticeDateBlock';
export const NOTICE_METHOD_BLOCK_ID = 'noticeMethodBlock';
export const OBJECTS_BLOCK_ID = 'objectsBlock';
export const OBJECTS_RESULTS_TITLE_BLOCK_ID = 'objectsResultsTitleBlock';
export const OGRN_LABEL_BLOCK_ID = 'ogrnLabelBlock';
export const ORDER_DATE_BLOCK_ID = 'orderDateBlock';
export const ORDER_NUMBER_BLOCK_ID = 'orderNumberBlock';
export const ORGANIZATION_NAME_BLOCK_ID = 'organizationNameBlock';
export const PROSECUTOR_ORGANIZATION_BLOCK_ID = 'prosecutorOrganizationBlock';
export const REASONS_TITLE_BLOCK_ID = 'reasonsTitleBlock';
export const REQUIREMENTS_TITLE_BLOCK_ID = 'requirementsTitleBlock';
export const SIGNER_FULL_NAME_BLOCK_ID = 'signerFullNameBlock';
export const SIGNER_POSITION_BLOCK_ID = 'signerPositionBlock';
export const START_DATE_BLOCK_ID = 'startDateBlock';
export const STOP_DATE_BLOCK_ID = 'stopDateBlock';
export const SUBJECT_TYPE_BLOCK_ID = 'subjectTypeBlock';
export const SUPERVISION_TYPE_BLOCK_ID = 'supervisionTypeBlock';
export const TYPE_BLOCK_ID = 'typeBlock';
export const VIOLATIONS_LAWSUITS_TITLE_BLOCK_ID = 'violationsLawsuitsTitleBlock';
export const REJECT_REASON_BLOCK_ID = 'rejectReasons';
export const AUDITED_PERSON_AUTHORITY_TITLE_BLOCK_ID = 'auditedPersonAuthorityTitleBlock';
export const KNM_NOTIFICATION_BLOCK_ID = 'subjectNotifications';
export const KNM_NOTIFICATION_TITLE_BLOCK_ID = 'subjectNotificationsTitleBlock';
export const PM_REJECT_TITLE_BLOCK_ID = 'rejectTitleBlock';
export const FEDERAL_LAW_BLOCK_ID = 'federalLawBlock';
export const getChecklistBlockId = (id: string) => `checklists[${id}]`;
export const getCollaboratingOrganizationBlockId = (id: string) => `collaboratingOrganizations[${id}]`;
export const getDocumentBlockId = (id: string) => `documents[${id}]`;
export const getEventBlockId = (id: string) => `events[${id}]`;
export const getInspectorBlockId = (id: string) => `inspectors[${id}]`;
export const getInspectorErvkBlockId = (id: string) => `inspectorsErvk[${id}]`;
export const getOrganizationBlockId = (id: string) => `organizations[${id}]`;
export const getObjectBlockId = (id: string) => `objects[${id}]`;
export const getActFamiliarizationNotificationsBlockId = (id: string) => `act.familiarizationNotifications[${id}]`;
export const getObjectNameBlockId = (id: string) => `objects[${id}].name`;
export const getObjectAddressBlockId = (id: string) => `objects[${id}].address`;
export const getObjectPMAddressBlockId = (id: string) => `objectsPm[${id}].address`;
export const getObjectManualAddressBlockId = (id: string) => `objects[${id}].manualAddress`;
export const getObjectRegionBlockId = (id: string) => `objects[${id}].region`;
export const getObjectTypeBlockId = (id: string) => `objects[${id}].objectType`;
export const getObjectKindBlockId = (id: string) => `objects[${id}].objectKind`;
export const getObjectSubKindBlockId = (id: string) => `objects[${id}].objectSubKind`;
export const getObjectRiskCategoryBlockId = (id: string) => `objects[${id}].riskCategory`;
export const getObjectDangerClassBlockId = (id: string) => `objects[${id}].dangerClass`;
export const getObjectResultBlockId = (id: string) => `objectsResults[${id}]`;
export const getReasonBlockId = (id: string) => `reasons[${id}]`;
export const getRejectReasonBlockId = (id: string) => `rejectReasons[${id}]`;
export const getRequirementBlockId = (id: string) => `requirements[${id}]`;
export const getResultsCancellationInfoBlockId = (id: string) => `resultsCancellationInfo[${id}]`;
export const getViolationBlockId = (id: string) => `violations[${id}]`;
export const getViolationLawsuitBlockId = (id: string) => `violationsLawsuits[${id}]`;
export const getNotificationBlockId = (id: string) => `subjectNotifications[${id}]`;
export const getPmRejectBlockId = (id: string) => `pmReject[${id}]`;
export const getResultDecisionBlockId = (id: string | undefined) => `resultDecisions[${id}]`;
export const getResultDecisionFamiliarizationNotificationsBlockId = (rId: string, fId: string) =>
  `resultDecisions[${rId}].familiarizationNotifications[${fId}]`;
export const getAgreementsBlockId = (id: string | undefined) => `agreements[${id}]`;
